import React, { useMemo } from "react";
import BetVerifyContent from "../components/BetVerify/BetVerifyContent";

export default function BetVerify(props) {

  return useMemo(() => <BetVerifyContent {...props} />, [props]);
}
